import React from 'react';
import PlayerProfile from './sub/PlayerProfile';
import PlayerSeasonRecord from './sub/PlayerSeasonRecord';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PlayerBasicData from './sub/PlayerBasicData';

function ProfileImage(props) {
    let playerObj = props['profile'];

    return (
        <>
            <PlayerProfile profile={playerObj}/>
        </>
    );
}

export default ProfileImage;